import about1 from '../assets/about01.png';
import about2 from '../assets/about02.png';
import about3 from '../assets/about03.png';
import about4 from '../assets/about04.png';

export const aboutData= [
    {
        image: about1,
        title: 'Web Designer',
        about : 'I am a web designer with a passion for creating beautiful and functional web applications.',
      },{
        image: about2,
        title: 'React Developer',
        about : 'I am a React developer with a strong passion for creating beautiful and functional web applications using React.',
      },
      {
        image: about3,
        title: 'Backend Developer',
        about : 'I am a Backend developer with a strong passion for creating beautiful and functional web applications using PHP.',
      },
      {
        image: about4,
        title: 'Frontend Developer',
        about : 'I am a Frontend developer with a strong passion for creating beautiful and functional web applications using React and SCSS.', 
      }

]